import { ensureString } from 'ensure-string';
import Papa from 'papaparse';
import { Analysis } from "../index.js";
/**
 * Creates a new Chromatogram element based in a JCAMP string
 * @param text - String containing the JCAMP data
 * @param arrayBuffer
 * @returns - New class element with the given data
 */
export function fromPerkinElmerCSV(arrayBuffer) {
    const text = ensureString(arrayBuffer);
    const parsed = Papa.parse(text, {
        skipEmptyLines: true,
        header: true,
        dynamicTyping: true,
    }).data;
    const analysis = new Analysis();
    analysis.pushSpectrum({
        x: {
            data: parsed.map((d) => d['Sample Temperature']),
            label: 'Sample temperature [°C]',
            isDependent: true,
        },
        y: {
            data: parsed.map((d) => d['Unsubtracted Weight']),
            label: 'Weight [mg]',
            isDependent: true,
        },
        p: {
            data: parsed.map((d) => d['Program Temperature']),
            label: 'Program temperature [°C]',
            isDependent: true,
        },
        t: {
            data: parsed.map((d) => d.Time),
            label: 'Time [min]',
            isDependent: false,
        },
    }, { dataType: 'TGA' });
    return analysis;
}
//# sourceMappingURL=fromPerkinElmerCSV.js.map